import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { etiquetaEstadoFiltro } from '../../../utils/chequeTerceroDisplay';

export type FiltroActivoChip = {
  id: string;
  label: string;
  onDelete: () => void;
};

interface ChequesTerceroFiltrosActivosProps {
  chips: FiltroActivoChip[];
  totalCount: number;
  loading: boolean;
}

const ChequesTerceroFiltrosActivos: React.FC<ChequesTerceroFiltrosActivosProps> = ({
  chips,
  totalCount,
  loading,
}) => {
  if (chips.length === 0 && !loading) return null;

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center" sx={{ mb: 2 }}>
      {chips.length > 0 && (
        <>
          <Typography variant="body2" color="text.secondary" sx={{ mr: 0.5 }}>
            Filtros:
          </Typography>
          {chips.map((c) => (
            <Chip key={c.id} label={c.label} size="small" onDelete={c.onDelete} sx={{ maxWidth: 280 }} />
          ))}
        </>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ ml: chips.length ? 1 : 0 }}>
        {loading ? 'Buscando…' : `${totalCount} resultado${totalCount === 1 ? '' : 's'}`}
      </Typography>
    </Stack>
  );
};

export function buildEstadoChipLabel(estado: string): string {
  return `Estado: ${etiquetaEstadoFiltro(estado)}`;
}

export default ChequesTerceroFiltrosActivos;
